import React, { Component } from 'react';

import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import { formatLocale } from '../../../helpers/formatLocale';
import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../components/commonStyle.css';
import s from './FooterSettingsForm.css';



export class FooterSettingsForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedLanguages: []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { dynamicFooterTitle1 } = nextProps;
        let filteredLanguages = dynamicFooterTitle1?.map((item) => { return item?.language })
        this.setState({ selectedLanguages: filteredLanguages });
    }

    renderFieldArray = ({ fields, meta: { touched, error }, label }) => {
        const { formatMessage } = this.props.intl;
        const { languageList } = this.props;
        const { selectedLanguages } = this.state;

        return (
            <div className={bt.languageBox}>
                {fields && fields.map((footer, index) => {
                    let fieldLength = fields.length - 1;
                    const currentLanguage = fields?.get(index)?.language;
                    const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
                    const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }]
                    const languagesOptionFormatted = availableLanguages.map((locale) => {
                        return {
                            value: locale,
                            label: formatLocale(locale)
                        }
                    })
                    languagesOption.push(...languagesOptionFormatted)
                    return (
                        <div key={`${index}`}>
                            <div className='oneColumnGrid'>
                                <div className='twoColumnGrid'>
                                    <Field
                                        name={`${footer}.language`}
                                        component={SelectFieldComponent}
                                        label={formatMessage(messages.language)}
                                        options={languagesOption}
                                        inputClass={cx(bt.formControlSelect)}

                                    />
                                </div>
                                <div className='twoColumnGrid'>
                                    <div className='oneColumnGrid'>
                                        <Field
                                            name={`${footer}.value`}
                                            type="text"
                                            component={InputFieldComponent}
                                            label={label}
                                            placeholder={label}
                                            inputClass={bt.formControlInput} />
                                        <Field
                                            name={`${footer}.urlTitle`}
                                            type="text"
                                            component={InputFieldComponent}
                                            label={formatMessage(messages.footerUrltitle)}
                                            placeholder={formatMessage(messages.footerUrltitle)}
                                            inputClass={bt.formControlInput} />
                                    </div>
                                    <Field
                                        name={`${footer}.description`}
                                        type="text"
                                        component={InputFieldComponent}
                                        componentClass="textarea"
                                        label={formatMessage(messages.footerContent1)}
                                        placeholder={formatMessage(messages.footerContent1)}
                                        inputClass={cx(bt.formTextArea, bt.descTextArea)} />
                                </div>
                            </div>
                            <div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })} >
                                {(fields.length <= languageList?.length - 1) && fieldLength == index &&
                                    <Button className={cx(bt.languageBtn)} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
                                        <AddContentPlusIcon />
                                        <span>	{formatMessage(messages.addLanguage)}</span>
                                    </Button>
                                }
                                {fieldLength > 0 && <div>
                                    <Button className={cx(bt.languageBtn, bt.languageDeleteBtn)} onClick={() => fields.remove(index)}>
                                        <DeleteContentPlusIcon />
                                        <span>{formatMessage(messages.deleteLanguage)}</span>
                                    </Button>
                                </div>}
                            </div>
                        </div>
                    )
                })}
            </div >
        )
    }

    render() {
        const { handleSubmit, footerLogo1, footerLogo2, footerLogo3, footerLogo4, loading, submitting } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.footerSectionSettings)}</h1>
                <div className='twoColumnGrid'>
                    <Field name="footerBottom"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.copyRightcontent)}
                        placeholder={formatMessage(messages.copyRightcontent)}
                        inputClass={bt.formControlInput} />
                </div>
                <div className={bt.sectionDividerBorder} />
                <FieldArray
                    name="footerTitle1"
                    type="text"
                    component={this.renderFieldArray}
                    label={formatMessage(messages.footerTitle1)} />

                <div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'singleFlexEndBtn')}>
                    <Loader
                        type={"button"}
                        label={formatMessage(messages.submitButton)}
                        show={loading}
                        buttonType={'submit'}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        disabled={submitting || loading}
                    />
                </div>
            </Form>
        )
    }
}
FooterSettingsForm = reduxForm({
    form: 'FooterSettingsForm',
    onSubmit: submit,
    validate
})(FooterSettingsForm);
const selector = formValueSelector('FooterSettingsForm')
const mapState = (state) => ({
    footerLogo1: selector(state, 'footerLogo1'),
    footerLogo2: selector(state, 'footerLogo2'),
    footerLogo3: selector(state, 'footerLogo3'),
    footerLogo4: selector(state, 'footerLogo4'),
    loading: state.loader.FooterSettingsForm,
    dynamicFooterTitle1: selector(state, 'footerTitle1'),
    languageList: state?.runtime?.availableLocales,
})
const mapDispatch = {

}
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(FooterSettingsForm)));
